import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=2342b950&scoped=true"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"
import style0 from "./Live.vue?vue&type=style&index=0&id=2342b950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2342b950",
  null
  
)

export default component.exports